module.exports = __webpack_public_path__ + "static/img/index_banner2.cb496ff.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/index_banner2.png
// module id = 7ZmL
// module chunks = 1